module.exports = __webpack_public_path__ + "3582211a3ddf5831ccfd1358fb92f7ca.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/checkout/en/bosta_new.svg
// module id = ./app/images/checkout/en/bosta_new.svg
// module chunks = 40